import { Component, Inject, Input } from '@angular/core';
import { ModalService } from '../../modal/modal.service';
import { RescheduleService } from '../reschedule.service';
import { ClientData } from '../client-data';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CancelAppt } from '../reschedule/CancelAppt';

@Component({
    selector: 'app-cancel-appointment',
    template: `<h4>Are you sure you want to cancel this appointment?</h4>
					<div class="dcf-pt-5">
						<button type="button" class="dcf-btn dcf-btn-secondary close-modal-button" (click)="closeCancelling()">No, do not Cancel</button>
						<button type="button" id="cancel-button" class="dcf-btn dcf-btn-primary" (click)="cancelAppointment()">Yes, cancel</button>
					</div>`,
    standalone: false
})
export class CancelAppointment {

  @Input() token!: String;
  @Input() clientData!: ClientData;

  cancelling = false;

  constructor(
    public dialogRef: MatDialogRef<CancelAppointment>, 
    @Inject(MAT_DIALOG_DATA) public data: CancelAppt,
    private rescheduleService: RescheduleService
  ) {
    
  };

  closeCancelling() {
    this.dialogRef.close(false);
  }
 
  cancelAppointment() {
    if (this.cancelling) return;

    if (this.data.token === null) return;
    this.cancelling = true;
  
    const token = this.data.token as string
    this.rescheduleService.cancelAppointment(token, this.data.clientData.firstName, this.data.clientData.lastName, this.data.clientData.email, this.data.clientData.phone)
      .subscribe((result) => {
        this.cancelling = false;
        if (result.success) {
          document.body.scrollTop = document.documentElement.scrollTop = 0;
          this.dialogRef.close(true);

          // Let the user know it was successful
          // NotificationUtilities.giveNotice("Success!", "This appointment was successfully cancelled.", true);
        } else {
          document.body.scrollTop = document.documentElement.scrollTop = 0;
          this.dialogRef.close(false);

          // Let the user know it failed
          // NotificationUtilities.giveNotice("Failure", "Something went wrong and this appointment was not cancelled!", false);
        }
    })
  }
}